import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Column, Heading, Hr, Row, Section, Text } from "@react-email/components";
import TokenImage from "./components/token-image";
import { format } from 'date-fns';
import Card from "./components/card";
import Footer from "./components/footer";
import Container from "./components/container";
import BigButton from "./components/big-button";
import { formatInvoiceNumber } from "../utils";
const surtitleStyle = {
    color: '#545454',
    fontWeight: 500
};
const totalStyle = {
    fontWeight: 'bold',
    fontSize: '24px'
};
const dueDateStyle = {
    color: '#545454',
    fontSize: '14px'
};
const labelStyle = {
    color: '#545454',
    fontSize: '16px',
    margin: '0 0 8px 0'
};
const valueStyle = {
    color: '#1A1A1A',
    margin: '0 0 8px 0'
};
const tableStyle = {
    marginTop: '20px',
    marginBottom: '20px',
};
const headerStyle = {
    fontSize: '20px',
    fontWeight: 600
};
const column20Style = {
    width: '20%'
};
const column25Style = {
    width: '25%',
    whiteSpace: 'nowrap'
};
const column15Style = {
    width: '15%'
};
const column60Style = {
    width: '60%'
};
const textSubtitleStyle = {
    fontSize: '18px',
    fontWeight: 600,
    marginTop: '0px'
};
const itemsStyle = {
    fontWeight: 500,
};
const itemsRowStyle = {
    paddingBottom: '8px',
    paddingTop: '8px'
};
const downloadInvoiceLinkStyle = {
    color: '#38A057',
    marginTop: '10px',
    marginBottom: '10px',
    fontWeight: 400
};
const nowrap = {
    whiteSpace: 'nowrap',
    paddingLeft: '5px'
};
const Invoice = ({ from, to, total, dueDate, payLink, number, token, items, invoiceLink }) => {
    return (_jsxs(Container, { children: [_jsx(Heading, { as: 'h2', style: headerStyle, children: from }), _jsxs(Card, { children: [_jsxs(Text, { style: surtitleStyle, children: ["Invoice from ", from] }), _jsxs(Text, { style: totalStyle, children: ["$ ", total.toLocaleString(), " ", token] }), _jsxs(Text, { style: dueDateStyle, children: ["Due ", format(dueDate, 'MMM do, yyyy')] }), _jsx(Hr, {}), _jsx(Button, { href: invoiceLink, style: downloadInvoiceLinkStyle, children: "\u00A0\u2193\u00A0\u00A0Download Invoice" }), _jsxs(Section, { style: tableStyle, children: [_jsxs(Row, { children: [_jsx(Column, { style: column20Style, children: _jsx(Text, { style: labelStyle, children: "To" }) }), _jsx(Column, { children: _jsx(Text, { style: valueStyle, children: to }) })] }), _jsxs(Row, { children: [_jsx(Column, { style: column20Style, children: _jsx(Text, { style: labelStyle, children: "From" }) }), _jsx(Column, { children: _jsx(Row, { children: _jsx(Text, { style: valueStyle, children: from }) }) })] })] }), _jsx(BigButton, { href: payLink, children: "Pay this invoice" })] }), _jsxs(Card, { children: [_jsxs(Heading, { as: 'h3', style: textSubtitleStyle, children: ["Invoice #", formatInvoiceNumber(number)] }), _jsxs(Section, { style: itemsStyle, children: [items.map((item, index) => (_jsxs(Row, { style: itemsRowStyle, children: [_jsx(Column, { style: column60Style, children: item.description }), _jsx(Column, { style: column15Style, children: item.quantity }), _jsx(Column, { style: column25Style, children: _jsxs(Row, { children: [_jsx(Column, { children: _jsx(TokenImage, { token: token }) }), _jsxs(Column, { style: nowrap, children: [item.unitValue.toLocaleString(), " ", token] })] }) })] }, index))), _jsx(Hr, {}), _jsxs(Row, { style: itemsRowStyle, children: [_jsx(Column, { style: column60Style, children: "Total" }), _jsx(Column, { style: column15Style }), _jsx(Column, { style: column25Style, children: _jsxs(Row, { children: [_jsx(Column, { children: _jsx(TokenImage, { token: token }) }), _jsxs(Column, { style: nowrap, children: [total.toLocaleString(), " ", token] })] }) })] })] })] }), _jsx(Footer, {})] }));
};
Invoice.PreviewProps = {
    number: 100,
    from: 'Ofspace',
    to: 'John Doe',
    total: 100,
    dueDate: new Date(),
    payLink: 'https://example.com',
    invoiceLink: 'https://example.com',
    token: 'USDC',
    items: [
        {
            description: 'Item 1',
            quantity: 2,
            unitValue: 100,
        },
        {
            description: 'Item 2',
            quantity: 2,
            unitValue: 100,
        }
    ]
};
export default Invoice;
